import { loginWithEmail } from './api.js';

/**
 * Handle user login flow
 * @param {string} email User email
 * @param {string} verifyCode Verification code
 * @param {Function} onSuccess Callback on successful login, receives user info
 * @param {Function} onError Callback on error, receives error object
 */
export const handleLogin = async (email, verifyCode, onSuccess, onError) => {
    try {
        const res = await loginWithEmail(email, verifyCode);
        // Robust handling of nested userInfo response
        let user = null;
        if (res.data) {
             if (res.data.userInfo) {
                 user = res.data.userInfo;
                 // Handle double nesting if present (e.g. from previous bug or backend quirk)
                 if (user.userInfo) {
                     user = user.userInfo;
                 }
             } else {
                 // Fallback if userInfo is direct property or structured differently
                 user = res.data;
             }
        }

        if (user) {
            onSuccess(user);
        } else {
            throw new Error("Invalid response format");
        }
    } catch (e) {
        if (onError) {
            onError(e);
        } else {
            console.error("Login failed:", e);
            throw e;
        }
    }
};

